import { format } from 'date-fns'
import { rem } from 'polished'
import { formatPrice } from 'utils/money'
import { PrefillDestinationSearch } from './PrefillDestinationSearch'

export const fields = [
  {
    key: 'teamSize',
    question: 'How many people will attend your trip?',
    type: 'number',
    flexDirection: 'row',
    hideButtons: true,
    maxWidth: rem(96),
    isBlock: true,
    getFilledText: ({ teamSize }) => `${teamSize} people`,
  },
  {
    key: 'budget',
    question: 'What is your estimated total budget per person?',
    type: 'radio_chip',
    hideContinue: true,
    getFilledText: ({ budget: { maximumBudget, minimumBudget }, teamSize }) =>
      minimumBudget && maximumBudget
        ? `${formatPrice({ value: minimumBudget, currency: 'EUR' })} - ${formatPrice({ value: maximumBudget, currency: 'EUR' })} per person (est. total trip spend: ${formatPrice({ value: ((maximumBudget + minimumBudget) / 2) * teamSize, currency: 'EUR' })})`
        : maximumBudget
        ? `Less than ${formatPrice({ value: maximumBudget, currency: 'EUR' })} per person (est. total trip spend: ${formatPrice({ value: (maximumBudget - 100) * teamSize, currency: 'EUR' })})`
        : `More than ${formatPrice({ value: minimumBudget, currency: 'EUR' })} per person (est. total trip spend: ${formatPrice({ value: (minimumBudget + 200) * teamSize, currency: 'EUR' })})`,
    options: [
      {
        name: 'Less than 1,200€',
        value: {
          minimumBudget: 0,
          maximumBudget: 1200,
        },
      },
      {
        name: '1,200 - 1,800€',
        value: {
          minimumBudget: 1200,
          maximumBudget: 1800,
        },
      },
      {
        name: 'More than 1,800€',
        value: {
          minimumBudget: 1800,
          maximumBudget: undefined,
        },
      },
    ],
  },
  {
    type: 'radio',
    key: 'date',
    question: 'When would you like to go on your team trip?',
    getFilledText: ({
      date: { flexible, period, exactDate, value: { startDate, endDate } = {} },
    }) => {
      const isSameMonth = period
        ? format(new Date(startDate), 'MMMM yyyy') ===
          format(new Date(endDate), 'MMMM yyyy')
        : false

      return flexible
        ? `I don't know yet`
        : `${
            !isSameMonth
              ? `${format(
                  new Date(startDate),
                  exactDate ? 'd MMM' : 'MMMM'
                )} - `
              : ''
          }${format(new Date(endDate), exactDate ? 'd MMM yyyy' : 'MMMM yyyy')}`
    },
    options: [
      {
        type: 'datepicker',
        name: 'I know the exact dates',
        placeholder: 'Select dates...',
        exactDate: true,
        key: 'exactDate',
      },
      {
        name: 'I know the month or approximate period',
        type: 'monthpicker',
        placeholder: 'Select month(s)...',
        period: true,
        key: 'period',
      },
      {
        name: `I don't know yet`,
        flexible: true,
        key: 'flexible',
      },
    ],
  },
  {
    type: 'radio',
    key: 'destination',
    question: 'What destination are you considering?',
    getFilledText: ({ destination: { value, label, fromList, helpNeeded } }) =>
      helpNeeded ? `I don't know yet` : fromList ? label : value,
    options: [
      {
        type: 'destination_select',
        name: `I'll choose from the list`,
        placeholder: 'Select destination...',
        fromList: true,
        key: 'fromList',
      },
      {
        name: `Didn't find it in the list? Add a specific destination`,
        placeholder: 'Specify destination...',
        type: 'input',
        specific: true,
        key: 'specific',
        additionalContent: (value, onInputChange, additionalContentProps) => (
          <PrefillDestinationSearch
            value={value}
            additionalContentProps={additionalContentProps}
          />
        ),
      },

      {
        name: `I don't know yet`,
        helpNeeded: true,
        key: 'helpNeeded',
      },
    ],
  },
  {
    key: 'name',
    question: '🏷️ Name your trip',
    type: 'input',
    placeholder: 'Enter a trip name',
  },
]
